import { Injectable, inject, signal } from '@angular/core';
import { ApiService } from './api';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private api = inject(ApiService);
  private router = inject(Router);

  private readonly TOKEN_KEY = 'auth_token';

  // Signal to track login state reactively
  isAuthenticated = signal<boolean>(!!this.getToken());

  constructor() { }

  login(credentials: { email: string, password: string }): Observable<{ token: string }> {
    return this.api.post<{ token: string }>('admin/login', credentials).pipe(
      tap(response => {
        this.setToken(response.token);
      })
    );
  }

  logout(): void {
    localStorage.removeItem(this.TOKEN_KEY);
    this.isAuthenticated.set(false);
    this.router.navigate(['/admin/login']);
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  private setToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
    this.isAuthenticated.set(true);
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }
}
